"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shopInstore = exports.drawerItemText = exports.drawerItem = exports.drawerIcon = exports.list = void 0;

var _react = require("@emotion/react");

var _utils = require("../../../utils");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  .css-", " & {\n    padding-left: 400px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 20px 0 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var list = function list(theme) {
  return (0, _react.css)((0, _utils.mq)(theme)({
    width: ['100vw', '400px'],
    paddingTop: ['0', '20px']
  }));
};

exports.list = list;
var drawerIcon = (0, _react.css)(_templateObject());
exports.drawerIcon = drawerIcon;

var drawerItem = function drawerItem(theme) {
  return (0, _react.css)((0, _utils.mq)(theme)({
    borderRadius: '5px',
    margin: ['0', '0 20px'],
    padding: '15px 15px 15px 20px',
    color: theme.colors.neutral[600]
  }));
};

exports.drawerItem = drawerItem;
var drawerItemText = (0, _react.css)(_templateObject2(), drawerItem.name);
exports.drawerItemText = drawerItemText;

var showSm = function showSm(alwaysShowShopInstore, theme) {
  return (0, _react.css)((0, _utils.mq)(theme)({
    display: alwaysShowShopInstore ? ['flex'] : ['flex', 'none']
  }));
};

var shopInstore = function shopInstore(alwaysShowShopInstore) {
  return function (theme) {
    return (0, _react.css)(drawerItem(theme), showSm(alwaysShowShopInstore, theme));
  };
};

exports.shopInstore = shopInstore;